import { ServiceWorkerAbsenceStatus } from '@navio/nsdk';
import { BadgeVariant, NoddiBadge } from 'noddi-ui-web';
import { SERVICE_WORKER_ABSENCE_STATUS_LABEL_BY_VALUE } from 'noddi-util';

const STATUS_BADGE_VARIANT: Record<ServiceWorkerAbsenceStatus, BadgeVariant> = {
  [ServiceWorkerAbsenceStatus.PENDING]: 'warning',
  [ServiceWorkerAbsenceStatus.APPROVED]: 'success',
  [ServiceWorkerAbsenceStatus.REJECTED]: 'destructive',
  [ServiceWorkerAbsenceStatus.WITHDRAWN]: 'default'
};

export const AbsenceStatusBadge = ({
  status,
  className
}: {
  status: ServiceWorkerAbsenceStatus;
  className?: string;
}) => (
  <NoddiBadge variant={STATUS_BADGE_VARIANT[status]} className={className}>
    {SERVICE_WORKER_ABSENCE_STATUS_LABEL_BY_VALUE[status]}
  </NoddiBadge>
);
